import { Fragment } from 'react';

import { SmartTableCellProps } from '@/components/ui/daisy';

import { ActivityProgress } from '@/models/ActivityProgress';

export default function ActivityCell({
  item,
}: SmartTableCellProps<ActivityProgress>) {
  return <Fragment>{item.activity.name}</Fragment>;
}
